import React from 'react';
import {
  ActionButton,
  DefaultButton,
  CommandBar,
  CommandBarButton,
  Dropdown,
  PrimaryButton,
  ContextualMenu,
  Dialog,
  DialogType,
  DialogFooter,
  OverflowSet,
  Stack,
  ColorPicker,
  GroupedList,
  Label,
  ScrollablePane,
  ScrollbarVisibility,
  DetailsList,
  DetailsListLayoutMode,
  SearchBox,
  Selection,
  SelectionMode,
  SelectionZone,
  ShimmeredDetailsList,
  Slider,
  Sticky,
  StickyPositionType,
  Text,
  TextField,
  Toggle,
  CommandButton,
  Nav,
  FocusZone,
  Pivot,
  PivotItem,
  PivotLinkFormat,
  PivotLinkSize,
  IconButton,
  DatePicker,
  ComboBox,
  VirtualizedComboBox,
  FocusTrapCallout,
  Callout,
  DirectionalHint,
  FontIcon,
  FontSizes,
  FontWeights,
  Icon,
  Image,
  ImageFit,
  Link,
  TooltipHost,
  TooltipOverflowMode,
  ConstrainMode,
  Panel,
  PanelType,
  Checkbox,
  Layer,
  Overlay,
  ChoiceGroup,
  ProgressIndicator,
  CheckboxVisibility,
  Spinner,
  SpinnerSize,
  MessageBar,
  MessageBarType,
  List,
  TeachingBubble,
  getColorFromString,
  SwatchColorPicker,
  initializeIcons,
} from '@fluentui/react';

initializeIcons();

const ContextualMenuDropdown = props => (
  <ContextualMenu {...props} />
);

export {
  ContextualMenuDropdown as ContextualMenu,
  ActionButton,
  DefaultButton,
  CommandBar,
  CommandBarButton,
  PrimaryButton,
  Dialog,
  DialogType,
  DialogFooter,
  Dropdown,
  OverflowSet,
  Stack,
  ColorPicker,
  GroupedList,
  Label,
  ScrollablePane,
  ScrollbarVisibility,
  DetailsList,
  DetailsListLayoutMode,
  SearchBox,
  SelectionMode,
  ShimmeredDetailsList,
  Slider,
  Sticky,
  StickyPositionType,
  Text,
  TextField,
  Toggle,
  CommandButton,
  Nav,
  FocusZone,
  Pivot,
  PivotItem,
  PivotLinkFormat,
  PivotLinkSize,
  IconButton,
  DatePicker,
  ComboBox,
  VirtualizedComboBox,
  Selection,
  SelectionZone,
  FocusTrapCallout,
  Callout,
  DirectionalHint,
  FontIcon,
  FontSizes,
  FontWeights,
  Icon,
  Image,
  ImageFit,
  Link,
  TooltipHost,
  TooltipOverflowMode,
  ConstrainMode,
  Panel,
  PanelType,
  Checkbox,
  Layer,
  Overlay,
  ChoiceGroup,
  ProgressIndicator,
  CheckboxVisibility,
  Spinner,
  SpinnerSize,
  MessageBar,
  MessageBarType,
  List,
  TeachingBubble,
  getColorFromString,
  SwatchColorPicker,
};
